import ScrollLinksHandler from "../../Atom/ScrollLink/ScrollLink";

export default class Tabs {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.tabs'), el => {
            new Tabs(el);
        });
    }

    constructor(el) {
        this._element = el
        if (!this._element) {
            return;
        }

        this._buttonGroup = el.querySelector('.button-group')
        if (!this._buttonGroup) {
            return;
        }

        this._content = el.querySelector('.tabs__content')

        this._buttonGroup.addEventListener('click', (evt) => {
            this.handleButtonGroupClick(evt)
        })
    }

    handleButtonGroupClick(evt) {
        const clickedButtonLink = evt.target.closest('.button-group__link')
        if (!clickedButtonLink) {
            return;
        }

        evt.preventDefault();

        const id = clickedButtonLink.dataset.id
        this.setActiveButtonLink(id)
        this.setActiveContentItem(id)

        // Scroll to top of element
        // if the page has a hash menu, we needs extra space for the absolute positioned el
        const extraOffset = document.querySelector('.hash-menu') ? -81 : -15;
        ScrollLinksHandler.scrollToElement(this._element, extraOffset)
    }

    setActiveButtonLink(id) {
        for (const buttonGroupItem of this._buttonGroup.children) {
            const buttonLink = buttonGroupItem.querySelector('.button-group__link')
            if (buttonLink.dataset.id === id) {
                buttonGroupItem.classList.add('button-group__item--active')
            } else {
                buttonGroupItem.classList.remove('button-group__item--active')
            }
        }
    }

    setActiveContentItem(id) {
        for (const contentItem of this._content.children) {
            if (contentItem.getAttribute('id') === id) {
                contentItem.classList.add('tabs__content__item--active')
            } else {
                contentItem.classList.remove('tabs__content__item--active')
            }
        }
    }
}
